const downs = {
  path: 'downs',
  component: resolve => require(['../../../../../../../pages/admin/merchant/dispose/shopkeeper/downs'], resolve),
  meta: {
    requireAuth: true
  }
}

export default downs